import BasePerimeter from '@/kindergarten/perimeters/BasePerimiter';

export default new BasePerimeter({
  purpose: 'management_role',

  can: {
    route() {
      return this.child && (this.isAdmin() && this.isManagement());
    },
  },
});



// WEBPACK FOOTER //
// ./src/kindergarten/perimeters/ManagementPerimeter.js